export default class UserProfile {
  id;
  name;
  hash;
  accounts;
  status;
  externalId;

  constructor({ id, name, hash, accounts, status, externalId }) {
    this.id = id;
    this.name = name;
    this.hash = hash;
    this.accounts = accounts;
    this.status = status;
    this.externalId = externalId;
  }

  static fromJson(json) {
    const data = json.profile;
    const accounts = Array.isArray(data.account) ? data.account : [data.account];

    return new UserProfile({
      id: data.id,
      name: data.name,
      accounts: accounts,
      hash: data.hash,
      status: data.state ? data.state.toUpperCase() : '',
      externalId: data.external_id,
    });
  }

  get firstName() {
    try {
      return this.name.split(' ')[0];
    } catch (e) {
      console.error('Error getting first name:', e);
      return '';
    }
  }

  get lastName() {
    try {
      return this.name.split(' ').slice(1).join(' ').trim();
    } catch (e) {
      console.error('Error getting last name:', e);
      return '';
    }
  }

  get uuid() {
    try {
      return this.id.split('-').pop();
    } catch (e) {
      console.error('Error getting uuid:', e);
      return '';
    }
  }
}
